module.exports = __webpack_public_path__ + "img/banklist.29413207.jpg";